<template>
  <v-btn color="primary" to="/">{{ $t("home") }}</v-btn>
</template>

<script>
export default {
  name: "HomeBtn",
};
</script>

<style scoped>
a {
  color: #fff;
  text-decoration: none;
  font-size: 32px;
}
</style>
